// Import database client
import databaseClient from '../databaseClient';

// Allowed file types for About bucket (front-end guard; also enforce via policies)
const ALLOWED_EXTENSIONS = ['.json'];
const ALLOWED_MIME_TYPES = ['application/json'];

function getExtension(filePath) {
    const dot = filePath.lastIndexOf('.');
    return dot === -1 ? '' : filePath.substring(dot).toLowerCase();
}

// About storage name
const ABOUT_STORAGE = process.env.REACT_APP_DATABASE_ABOUT_STORAGE_PATH;

// Get about file signed url
export async function getAboutFileSignedUrl(filePath, timeout) {
    const { data, error } = await databaseClient.storage
        .from(ABOUT_STORAGE)
        .createSignedUrl(filePath, timeout);

    if (error) {
        throw error;
    }

    return data.signedUrl;
}

// Upload file on about bucket
export async function uploadAboutFile(filePath, file) {
    // Front-end validation for extension and mime-type
    const ext = getExtension(filePath);
    if (!ALLOWED_EXTENSIONS.includes(ext)) {
        throw new Error('Invalid file extension. Only .json is allowed');
    }
    if (file?.type && !ALLOWED_MIME_TYPES.includes(file.type)) {
        throw new Error('Invalid content type. Only application/json is allowed');
    }

    const { error } = await databaseClient.storage
        .from(ABOUT_STORAGE)
        .upload(filePath, file, {
            upsert: true, // Overwrite the file if it exist
            contentType: 'application/json',
        });

    if (error) {
        throw error;
    }
}
